module.exports = __webpack_public_path__ + "static/media/menu_corner_lower_left.1fc8d89a.png";